import { useSelector } from "react-redux";
import { CreateOrganization } from "../../../store/organization-store/organization-actions"; 
import OrganizationForms from "../../../components/Forms/OrganizationForms";
import { GetOrganizations } from "../../../store/organization-store/organization-actions";
import { getTokenInfo } from "../../../utils/Guard";

const OrganizationCreate = () => {
  const userInfo = getTokenInfo();
  const organization = useSelector((state) => state.organization.organization);
  


  return (
    <>
    <div style={{ backgroundColor: "#133047", padding: "1%", height: "62.5rem" }}>
      <OrganizationForms actionOrganization={CreateOrganization} organization={organization} />
    </div>
    </>
  );
};
export default OrganizationCreate;
